import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import useGrillData from './useGrillData';

const GrillType = ({ value, onChange, id = 'GrillType', label = 'Grill Type', disabled = false, showPics = false, appliesTo = 'windows' }) => {
    const defaultValue = value?.value || '';
    const [selectedGrillType, setSelectedGrillType] = useState(defaultValue);
    const [showModal, setShowModal] = useState(false);
    const { getGrillTypes, loading, error } = useGrillData(appliesTo);

    const grillTypes = getGrillTypes();

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedGrillType(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when options are loaded
    useEffect(() => {
        if (!loading && grillTypes.length > 0 && !selectedGrillType) {
            const defaultOption = grillTypes[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedGrillType(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, [loading, grillTypes]);

    const handleGrillTypeChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedGrillType(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    if (error) {
        console.error('Error loading grill types:', error);
    }

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGrillType}
                onChange={handleGrillTypeChange}
            >
                {loading ? (
                    <option value="">Loading...</option>
                ) : (
                    grillTypes.map(option => (
                        <option key={option.id} value={option.value}>
                            {selectedGrillType === option.value ? `${option.label} ✔` : option.label}
                        </option>
                    ))
                )}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/Grilltype"
                imageName={selectedGrillType}
                width={200}
                height={250}
            />
        </div>
    );
};

export default GrillType;
